import { types } from "./types";

const initialized = (initialized) => {
    return {
        type: types.initialized,
        payload: initialized
    }
}

const login = (user, membership = {}, nutritionalProfile = {}) => {
    return {
        type: types.login,
        payload: {
            user,
            membership,
            nutritionalProfile,
        },
    };
};


const logout = () => {
    return {
        type: types.logout,
    };
};


const updateAvatar = (avatar = '') => {
    return {
        type: types.updateUser,
        payload: { avatar },
    };
}


const updateUser = (data = {}) => {
    return {
        type: types.updateUser,
        payload: { ...data },
    }
}


const updateMembership = (data = {}) => {
    return {
        type: types.updateMembership,
        payload: { ...data },
    };
};


const updateNutritionalProfile = (data = {}) => {
    return {
        type: types.updateNutritionalProfile,
        payload: { ...data },
    };
};


export {
    initialized,
    login,
    logout,
    updateAvatar,
    updateUser,
    updateMembership,
    updateNutritionalProfile,
};
